const signature = document.querySelector('.js-signature');

if(signature) {
    var app = new Vue({
        el: '#app',
        data: {
            company: 'Cookinglife',
            name: 'My name',
            role: 'My role',
            mail: 'mail',
            phone: '+31 88 145 1400',
            clPhone: '+31 (0)85 303 8900',
            wrPhone: '+31 (0)50 820 0244',
            mobile: '',
            available: '9.00 - 12.00 / 12.30 - 17.30 uur',
            subtext: ''
        },
        computed: {
            availabilty: function () {
                if (this.company == 'cookingde') {
                    return 'Verf&uuml;gbarkeit';
                } else {
                    return 'Bereikbaar / Available';
                }
            },
            color: function () {
                return '#DD195A';
            },
            countrySuffix: function () {
                if (this.company == 'cookingde' || this.company == 'cookingbe') {
                    return ', NL';
                } else {
                    return '';
                }
            },
            csNumber: function () {
                if (this.company == 'cookingde') {
                    return '+49 203 80 481 54';
                } else if (this.company == 'cookingbe') {
                    return '+32 380 84 375';
                } else {
                    return '+31 88 145 1499';
                }
            },
            houseNr: function () {
                return 40;
            },
            logo: function () {
                if (this.company == 'woldring') {
                    return 'https://60cafc33af40b8287ffb-1a032c1af87160c7fc01b9de8fd3221e.ssl.cf3.rackcdn.com/logo_woldring1.png';
                } else {
                    return 'https://cdn.shopify.com/s/files/1/0590/1366/0750/files/image_x320.svg?v=1709819644';
                }
            },
            salutation: function () {
                if (this.company == 'cookingde') {
                    return 'Mit freundlichen Gr&uuml;&szlig;en,';
                } else {
                    return 'Met vriendelijke groet / Kind regards,';
                }
            },
            url: function () {
                if (this.company == 'cookingde') {
                    return 'cookinglife.de';
                } else if (this.company == 'cookingbe') {
                    return 'cookinglife.be';
                } else if (this.company == 'woldring') {
                    return 'woldring.nl';
                } else {
                    return 'cookinglife.nl';
                }
            },
            linkedIn: function () {
                if (this.company == 'cookinglife') {
                    return 'cookinglife';
                }
            },
            instagram: function () {
                if (this.company == 'cookingde') {
                    return 'cookinglife_international/';
                } else if (this.company == 'woldring') {
                    return 'woldringnl/';
                } else {
                    return 'cookinglifenl/';
                }
            },
            facebook: function () {
                if (this.company == 'cookingde') {
                    return 'Cookinglifenl/';
                } else if (this.company == 'woldring') {
                    return 'AanTafelmetWoldring/';
                } else {
                    return 'Cookinglifenl/';
                }
            },
            pinterest: function () {
                if (this.company == 'cookingde') {
                    return 'https://www.pinterest.de/Cookinglifede/';
                } else if (this.company == 'woldring') {
                    return 'https://nl.pinterest.com/bijWoldring/';
                } else {
                    return 'https://nl.pinterest.com/Cookinglifenl/';
                }
            }
        },
        methods: {
            copy: function () {
                var range = document.createRange();
                var selection = window.getSelection();

                range.selectNodeContents(document.getElementById('signature'));
                selection.removeAllRanges();
                selection.addRange(range);
                document.execCommand('Copy');
                selection.removeAllRanges();

                alert('Copied to clipboard');
            }
        }
    });
}
